import { faArrowRight, faLandmark, faLocationDot, faShip, faTruck } from "@fortawesome/pro-duotone-svg-icons";
import { faCube } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const colorMap = {
    inTransit: {
        color: "text-teal-500",
        bg: "bg-teal-100",
        bar: "bg-teal-400",
        icon: faShip,
    },
    arriving: {
        color: "text-amber-500",
        bg: "bg-amber-100",
        bar: "bg-amber-400",
        icon: faLocationDot,
    },
    deliveryScheduled: {
        color: "text-cyan-500",
        bg: "bg-cyan-100",
        bar: "bg-cyan-400",
        icon: faTruck,
    },
    onSite: {
        color: "text-orange-500",
        bg: "bg-orange-100",
        bar: "bg-orange-400",
        icon: faLandmark,
    },
    stockReceiving: {
        color: "text-slate-500",
        bg: "bg-slate-100",
        bar: "bg-slate-400",
        icon: faCube,
    },
};

export default function GatewaySummary({ data }) {
    const location = useLocation();
    const navigate = useNavigate();
    return (
        <Card className="shadow-sm rounded-xl h-full">
            <div className="flex justify-between items-baseline mb-4">
                <span className="text-[18px] font-semibold">
                    Gateway Summary
                </span>
                <span className="text-[14px] text-primary hover:cursor-pointer" onClick={() => navigate("/shipment-gateway")}>
                    See more <FontAwesomeIcon icon={faArrowRight} />
                </span>
            </div>
            <div className="space-y-4">
                <SummaryRow
                    label="In Transit"
                    value={data?.inTransit}
                    theme={colorMap.inTransit}
                    handleClick={() => navigate("/shipment-gateway", { state: { pathname: location.pathname, activeTab: "inTransit" } })}
                />
                <SummaryRow
                    label="Arriving"
                    value={data?.arriving}
                    theme={colorMap.arriving}
                    handleClick={() => navigate("/shipment-gateway", { state: { pathname: location.pathname, activeTab: "arriving" } })}
                />
                <SummaryRow
                    label="Delivery Scheduled"
                    value={data?.deliveryScheduled}
                    theme={colorMap.deliveryScheduled}
                    handleClick={() => navigate("/shipment-gateway", { state: { pathname: location.pathname, activeTab: "deliveryScheduled" } })}
                />
                <SummaryRow
                    label="On Site"
                    value={data?.onSite}
                    theme={colorMap.onSite}
                    handleClick={() => navigate("/containers-on-site", { state: { pathname: location.pathname } })}
                />
                <SummaryRow
                    label="Stock Receiving"
                    value={data?.stockReceiving}
                    theme={colorMap.stockReceiving}
                    handleClick={() => navigate("/shipment-gateway", { state: { pathname: location.pathname, activeTab: "stockReceiving" } })}
                />
            </div>
        </Card>
    );
}

function SummaryRow({ label, value, theme, handleClick }) {
    return (
        <div className="hover:cursor-pointer" onClick={handleClick}>
            <div className="flex justify-between items-center mb-2">
                <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${theme.bg}`}>
                        <FontAwesomeIcon icon={theme.icon} className={`${theme.color} text-sm`} />
                    </div>
                    <span className="text-sm font-semibold text-gray-600">
                        {label}
                    </span>
                </div>
                <span className="font-semibold">
                    {value}
                </span>
            </div>
            <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                <div className={`${theme.bar} h-full rounded-full transition-all duration-500`} />
            </div>
        </div>
    );
}